<template lang="pug">
  main
    //- ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="deleteFactura")
    ModalInfo(v-show="modalStatus2" :title="titleModal2" :content="contentModal2" @padre:close="cerrarModal")
    NavBarRequisiciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Requisiciones &nbsp
              |
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='periodo'
                  :config="config"
                  class="input"
                )
          .column.is-2
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Proveedor | Cantidad | Fecha ',
                  v-model="query",
                )
          .column.is-5(v-show="!userNormal")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='filter' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='filter')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='filter')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-1
            a.button.is-success.is-rounded.is-small(@click="descargarRequisiciones")
              span.icon.is-small
                i.fas.fa-download
              span Requisición
          .column.is-2
            router-link.a.button.is-black.is-rounded.is-small(to="/Requisiciones/Nueva")
              span.icon
                i.fas.fa-plus
              | &nbspNueva
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns.has-text-centered
          .column.is-12(v-show="requisicionesShow.length > 0")
            table#tbRequisiciones.table.is-striped.is-responsive.is-fullwidth
              thead
                tr
                  th #
                  th Requisición
                  th Descripción
                  th Datos Financieros
                  th Estado
              tbody
                tr(v-for="(data, index) in requisicionesShow" :key="data.id_requisicion")
                  td 
                    span.tag.is-black
                      | {{ index + 1 }}
                  td 
                    a.button.is-text.is-rounded(@click="editarRequisicion(data)")
                      | {{ data.id_requisicion }}
                    br
                    a.button.is-black.is-rounded.is-small(v-show="parseInt(data.estado) > 0" @click="imprimirReq(data)")
                      i.fas.fa-print
                      | &nbsp Req.
                    a.button.is-dark.is-rounded.is-small(v-show="parseInt(data.estado) > 3" @click="imprimirOC(data)")
                      i.fas.fa-print
                      | &nbsp O.C.
                  td(v-html="getDataDescr(data)")
                  td
                    span.is-size-7
                      b
                        | Contacto: 
                        small.has-text-dark {{ data.nombreC }}
                      |  | 
                      b
                        | 📱 
                        small.has-text-dark {{ data.contacto }}
                      |  | 
                      b
                        | ✉️ 
                        small.has-text-dark {{ data.correo }}
                      br
                      b
                        | Banco: 
                        small.has-text-dark {{ data.banco }}
                      |  | 
                      b
                        | Cuenta: 
                        small.has-text-dark {{ data.cuenta }}
                      |  | 
                      b
                        | CLABE: 
                        small.has-text-dark {{ data.clabe }}
                      |  | 
                      br
                      b
                        | Total: 
                        small.has-text-dark {{ data.total | currency}}
                  td
                    a.button.is-rounded.is-small(:class="getClassEstado(data)" @click="firmar(data)")
                      b(v-html="getEstado(data)")
                      i.fas.fa-file-signature
        .columns(v-show="requisicionesShow.length === 0")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos para ésta Búsqueda.
        .columns.column-blanco  
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisiciones from './layout/NavBarRequisicion.vue'
  //import facturasServices from '../../services/facturas/facturas'
  import ModalDelete from '@/components/shared/ModalDelete.vue'
  import ModalInfo from '@/components/shared/ModalInfo.vue'
  import moment from 'moment'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'

  export default {
    name: 'Requisiciones',
    components: { Loader, NavBarRequisiciones, ModalDelete, ModalInfo, flatPickr },
    data() {
      return {
        isLoading: true,
        requisiciones: [],
        requisicionesShow: [],
        modalStatus: false,
        contentModal: '',
        titleModal: '',
        modalStatus2: false,
        contentModal2: '',
        titleModal2: '',
        requisicionSelected: '',
        userSol: {},
        userJA: {},
        userRev: {},
        userAut: {},
        userAutOC: {},
        usuarios: [],
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        periodo: moment().format('YYYY-MM'),
        query: '',
        filter: 'ALL',
        result_query: '',
        userNormal: true
      }
    },
    watch: {
      periodo() {
        this.obtenerRequisiciones()
      },
      query() {
        const QUERY_ARTICULOS = this.query.toUpperCase()
        if (this.query.length !== 0) {
          const _filter = this.requisiciones.filter( req => { 
            return `${req.nombreProvSel} ${req.contacto} ${req.direccion} ${req.banco}`.toUpperCase().includes(QUERY_ARTICULOS)
          }) 
          this.requisicionesShow = _filter
          this.result_query = this.requisicionesShow.length === 1 ? `Se encontró ${this.requisicionesShow.length} coincidencia.` : `Se encontraron ${this.requisicionesShow.length} coincidencias.`
        } else {
          this.requisicionesShow = this.requisiciones
          this.result_query = ''
        }
      },
      filter() {
        if (this.filter !== '') {
        console.log('filter')
          if (this.filter === 'ALL') {
            this.requisicionesShow = this.requisiciones
          } else {
            let _filter = []
            switch (this.filter) {
              case 'DUCTO':
                _filter = this.requisiciones.filter( (tarjet) => tarjet.ubicacion === 'EB00' || tarjet.ubicacion === 'EB01' || tarjet.ubicacion === 'EB02' || tarjet.ubicacion === 'EB03' || tarjet.ubicacion === 'EB04' || tarjet.ubicacion === 'ERM' || tarjet.ubicacion === 'LPG_DUCTO')
                this.requisicionesShow = _filter
                break
              case 'TPA':
                _filter = this.requisiciones.filter( (tarjet) => tarjet.ubicacion === 'TPA')
                this.requisicionesShow = _filter
                break
              case 'CORP':
                _filter = this.requisiciones.filter( (tarjet) => tarjet.ubicacion === 'CORP')
                this.requisicionesShow = _filter
                break
              case 'IRGE':
                _filter = this.requisiciones.filter( (tarjet) => tarjet.ubicacion === 'IRGE')
                this.requisicionesShow = _filter
                break
              default:
                this.requisicionesShow = this.requisiciones
                break
            }
          }
        }
      }
    },
    methods: {
      inciarComponente() {
        if (this.userLogin.cargo !== '000' || this.userLogin.cargo !== '002' || this.userLogin.cargo !== '2100' || this.userLogin.cargo !== '120' || this.userLogin.cargo !== '160' || this.userLogin.cargo !== '130' || this.userLogin.cargo !== '130') {
          this.userNormal = false
        }
        this.obtenerRequisiciones()
      },
      obtenerRequisiciones() {
        let tipo = ''
        let estadoFilter = 0
        switch (this.userLogin.categoria) {
          case 0:
            switch (this.userLogin.cargo) {
              case '000':
                tipo = 'GG'
                estadoFilter = 3
                break
              case '001':
                tipo = 'GP'
                estadoFilter = 0
                break
              case '002':
                tipo = 'GA'
                estadoFilter = 2
                break
              case '2100':
                tipo = 'GA'
                estadoFilter = 2
                break
              default:
                estadoFilter = 0
                break
            }
            break
          case 1:
            tipo = 'AG'
            estadoFilter = 0
            break
          case 2:
            tipo = 'JA'
            estadoFilter = 1
            break
          case 3:
            tipo = 'U'
            estadoFilter = 2
            break
        
          default:
            estadoFilter = 3
            break
        }

        InventarioServices.getRequisiciones(this.userLogin.id, tipo, this.periodo)
          .then(res => {
            console.log(res)
            this.requisiciones = res.map(this.convetirRequisiciones)
            this.requisicionesShow = this.requisiciones
            this.obtenerUsuarios()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`)
          })
      },

      convetirRequisiciones(req) {
        return {
          ...req,
          area: parseInt(req.area),
          entrega: parseInt(req.entrega),
          estado: parseInt(req.estado),
          moneda: parseInt(req.moneda),
          monedaP1: parseInt(req.monedaP1),
          monedaP2: parseInt(req.monedaP2),
          monedaP3: parseInt(req.monedaP3),
          presupuestada: parseInt(req.presupuestada),
          proveedorSel: parseInt(req.proveedorSel),
          tipo: parseInt(req.tipo)
        }
      },

      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then(res => {
            console.log(res)
            if (res.length > 0) {
              this.usuarios = res.map(this.convetirUsuarios)
              this.userAutOC = res.find( user => user.id === '1554871609265')
            } else {
              console.log('No hay datos.')
            }
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`)
          })
      },

      convetirUsuarios(user) {
        return {
          ...user,
          categoria: parseInt(user.categoria),
          departamento: parseInt(user.departamento),
          jefeArea: parseInt(user.jefeArea)
        }
      },

      getEstado (data) {
        let texto = ''
        switch (data.estado) {
          case 0:
            //Creada
            texto = `Firma Solicita&nbsp`
            break
          
          case 1:
            //Firmada por Gerentes
            texto = `Firma Gerente Planta&nbsp`
            break
          case 2:
            //OC.
            //Firmada por JA
            texto = `Firma Jefatura&nbsp`
            break
          case 3:
            //Firmada por GA
            texto = `Firma Gerente Admón.&nbsp`
            break
          case 4:
            //Firmada por Gg
            texto = `Firma Gerente Gral.&nbsp`
            break
          case 5:
            //Firmada por Gg
            texto = `Compra Aceptada&nbsp`
            break
          default:
            texto = ``
            break
        }
        return texto
      },

      getClassEstado (data) {
        let clase = ''
        switch (data.estado) {
          case '0':
            //Creada
            clase = 'is-warning'
            break
          case '1':
            //Firmada por Gerentes
            clase = 'is-link'
            break
          case '2':
            //OC.
            //Firmada por JA
            clase = 'is-info'
            break
          case '3':
            //Firmada por GA
            clase = 'is-success'
            break
          case '4':
            //Firmada por Gg
            clase = 'is-dark'
            break
          case '4':
            //Firmada por Gg
            clase = 'is-black'
            break
          default:
            break
        }
        return clase
      },

      cerrarModal () {
        this.modalStatus2 = false
      },

      getDataDescr (req) {
        let texto = ''
        let tipoStr = ''

        switch (parseInt(req.tipo)) {
          case 0:
            tipoStr = '<small class="has-text-link">Servicio</small>'
            break
          case 1:
            tipoStr = '<small class="has-text-info">Material</small>'
            break
          default:
            tipoStr = ''
            break
        }

        let inmStr = ''

        if (req.entrega === '0') {
          inmStr = 'Inmediata'
        } else {
          inmStr = `${req.entrega} días`
        }


        switch (parseInt(req.area)) {
          case 1:
            texto = `<span class="is-size-7"><b>Instrumentación ${tipoStr}</b><br />
            Entrega: ${inmStr} - Condiciones: ${req.condiciones} % Ant.
            </span>`
            break
          case 3:
            texto = `<span class="is-size-7"><b>Sistemas ${tipoStr}</b><br/>
            Entrega: ${inmStr} - Condiciones: ${req.condiciones} % Ant.
            </span>`
            break
          case 9:
            texto = `<span><b>Consumible <small class="has-text-info">${tipoStr}</small></b><br />
            Entrega: ${inmStr} - Condiciones: ${req.condiciones} % Ant.
            </span>`
            break
        
          default:
            texto = ''
            break
            
        }
        let ubi = req.ubicacion === 'LPG_DUCTO'? 'DUCTO' : req.ubicacion
        texto += `<br /><span class='tag is-black'>${ubi}</span>`

        return texto
      },

      imprimirReq (req) {
        let currentUrl = window.location.hostname
        let link
        console.log(currentUrl)

        let $userSol = this.usuarios.find( user => user.id === req.idUser_sol )

        console.log($userSol)
        link = `https://${currentUrl}/servidores/inventario/requisiciones/requiscionI.php?idR=${req.id_requisicion}&id=${req.id}&cargo=${$userSol.cargo}`
        console.log(link)
        if (open(link)) {
          console.log('Abriendo archivo')
        }
      },

      imprimirOC (req) {
        console.log(req)
        let currentUrl = window.location.hostname
        let tipo = 'pdf'
        let link = ''
        console.log(currentUrl)

        this.userSol = this.usuarios.find( user => user.id === req.idUser_sol )
        this.userJA = this.usuarios.find( user => user.id === req.idUser_JA )
        this.userRev = this.usuarios.find( user => user.id === req.idUser_rev )
        this.userAut = this.usuarios.find( user => user.id === req.idUser_aut )

        setTimeout(() => {
          link = `https://${currentUrl}/servidores/inventario/requisiciones/ordenCompraI.php?id=${req.id_requisicion}&fS=${this.userSol.avatar}&cargo=${this.userSol.cargo}`
          console.log(link)
          if (open(link)) {
            console.log('Abriendo archivo')
          }
        }, 350)
              
      },

      firmar (req) {
        console.log(req)

        switch (req.estado) {
          case 0:
            this.$store.commit('firmaRequisicion', req)
            this.$store.commit('estadoRequisicion', 0)
            this.$router.push('/Requisiciones/Firma')
            break
          case 1:
            if (this.userLogin.id === req.idUser_plantel) {
              this.$store.commit('firmaRequisicion', req)
              this.$store.commit('estadoRequisicion', 1)
              this.$router.push('/Requisiciones/Firma')
            } else {
              this.displayToast('No tiene Permisos para firmar esta Requisición', 'ban', 'Ok')
            } 
            break
          case 2:
            if (this.userLogin.id === req.idUser_JA) {
              this.$store.commit('firmaRequisicion', req)
              this.$store.commit('estadoRequisicion', 2)
              this.$router.push('/Requisiciones/Firma')
            } else {
              this.displayToast('No tiene Permisos para firmar esta Requisición', 'ban', 'Ok')
            }
            break
          case 3:
            if (this.userLogin.id === req.idUser_rev) {
              this.$store.commit('firmaRequisicion', req)
              this.$store.commit('estadoRequisicion', 3)
              this.$router.push('/Requisiciones/Firma')
            } else {
              this.displayToast('No tiene Permisos para firmar esta Requisición', 'ban', 'Ok')
            }
            break;
          case 4:
            if (this.userLogin.id === req.idUser_aut) { 
              this.$store.commit('firmaRequisicion', req)
              this.$store.commit('estadoRequisicion', 4)
              this.$router.push('/Requisiciones/Firma')
            } else {
              this.displayToast('No tiene Permisos para firmar esta Requisición', 'ban', 'Ok')
            }
            break
          case 5:
            this.$store.commit('firmaRequisicion', req)
            this.$store.commit('estadoRequisicion', 4)
            this.$router.push('/Requisiciones/Firma')
            break
          default:
            break;
        }

        
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      editarRequisicion(req) {
        this.$store.commit('editarRequisicion', req)
        this.$router.push('/Requisiciones/Editar')
      },
      backPage () {
        this.$router.back()
      },
      descargarRequisiciones () {

      }
    },
    created () {
      this.inciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    },

  }
</script>

<style lang="css" scoped>
  .container {
    width: 90%;
    max-width: 90%;
  }
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/Requisiciones.vue